import "./landing.css";

/**
 * Divisor de cinta tricolor: la franja amarilla/roja de la portada
 * saliendo del bloque navy hacia la sección clara siguiente.
 */
const CintaDivider = () => (
	<svg
		className="ld-cinta"
		viewBox="0 0 1440 120"
		preserveAspectRatio="none"
		aria-hidden="true"
		focusable="false"
	>
		<defs>
			<linearGradient id="ldCintaNavy" x1="0" y1="0" x2="1" y2="0">
				<stop offset="0" stopColor="#081C3E" />
				<stop offset="1" stopColor="#0954B4" />
			</linearGradient>
		</defs>
		{/* campo navy (empata con el gradiente de la banda de cifras) */}
		<path
			d="M0,55 C260,101 520,1 780,37 C1040,73 1240,57 1440,21 L1440,0 L0,0 Z"
			fill="url(#ldCintaNavy)"
		/>
		{/* franja amarilla */}
		<path
			d="M0,64 C260,110 520,10 780,46 C1040,82 1240,66 1440,30"
			fill="none"
			stroke="#FFD400"
			strokeWidth="20"
		/>
		{/* franja roja */}
		<path
			d="M0,82 C260,128 520,28 780,64 C1040,100 1240,84 1440,48"
			fill="none"
			stroke="#E20613"
			strokeWidth="20"
		/>
	</svg>
);

export default CintaDivider;
